<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="text-center d-none " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"background:rgba(0, 0, 0, 0.4)"' class="col-lg-12 text-white py-5 " >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":6219861905853155,"itemType":"text","iconName":"files"},...{}}' :style='""' class="col-12 mt-4 h3" >
                <template #default>6219861905853155
حامد مسعودی نژاد
   </template>
                </m-copy-1><m-p v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>IR930560611828005116555201   </template>
                </m-p><m-a v-bind='{...{"href":"tel:09365249788","target":"_self"},...{}}' :style='""' class="text-white" >
                <template #default>   <m-button-301 v-bind='{...{"type":"button","href":null,"target":"_self"},...{}}' :style='""' class="btn btn-secondary" >
                <template #default>09365249788   </template>
                </m-button-301></template>
                </m-a></template>
                </m-div></template>
                </m-div><m-factor-4 v-bind='{...{},...{}}' :style='""' class="my-5 py-5" ></m-factor-4>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mCopy1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Copy/Copy1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mButton301 from '@moeinmdn/miw-alpha-components/src/package/Buttons/Button301'; import mFactor4 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor4';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mCopy1,mP,mA,mButton301,mFactor4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
